var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_on)?_c('div',{attrs:{"id":"spinner"}},[_c('svg',{staticClass:"dot-spin",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }